module.exports = __webpack_public_path__ + "static/solar_details-53e9c521000eb9a24cf7a5e3cd2484c9.png";